__turbopack_context__.v({
  "imageContainer": "textWithMagicSymbol-module-scss-module___XIflq__imageContainer",
  "magicSymbol": "textWithMagicSymbol-module-scss-module___XIflq__magicSymbol",
});
